import { spacing, colors, font, breakpoints } from '@chegg-ui/theme';
import { Link } from '@chegg-ui/link';
import styled from 'styled-components';
export var MenuList = styled.ul.withConfig({
  componentId: "sc-1qa6ltt-0"
})(["display:flex;flex-direction:column;list-style:none;margin:0;padding:0;box-sizing:border-box;@media (min-width:", "){min-width:10.75rem;}"], breakpoints.lg.min);
export var MenuListItem = styled.li.withConfig({
  componentId: "sc-1qa6ltt-1"
})(["flex-grow:1;text-align:left;@media (max-width:", "){padding-left:calc(", " + ", ");}"], breakpoints.md.max, spacing.px12, spacing.px8);
export var MenuItemLink = styled(Link).withConfig({
  componentId: "sc-1qa6ltt-2"
})(["text-decoration:none;color:", ";font-weight:", ";font-size:", ";position:relative;padding:", " 0;width:100%;&:hover{font-weight:", ";text-decoration:none;}&:visited{color:", ";}&:focus{text-decoration:none;}@media (max-width:", "){font-weight:", ";&::before{content:'';display:", ";position:absolute;width:0.25rem;height:1.25rem;left:", ";top:", ";background-color:", ";}}"], colors.dark, font.weight.normal, font.size.px16, spacing.px16, font.weight.bold, colors.dark, breakpoints.md.max, function (props) {
  return props.isActive ? font.weight.bold : font.weight.normal;
}, function (props) {
  return props.isActive ? 'block' : 'none';
},
/* istanbul ignore next */
function (props) {
  return props.positionX && props.positionX < 0 ? "calc(-100vw + ".concat(Math.abs(props.positionX), "px)") : "-".concat(props.positionX, "px");
}, spacing.px12, colors.cheggOrange);